import { render, staticRenderFns } from "./devServiceProvideList.vue?vue&type=template&id=fe98f6da&scoped=true"
import script from "./devServiceProvideList.vue?vue&type=script&lang=js"
export * from "./devServiceProvideList.vue?vue&type=script&lang=js"
import style0 from "./devServiceProvideList.vue?vue&type=style&index=0&id=fe98f6da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe98f6da",
  null
  
)

export default component.exports